<th
  *ngIf="isLeftColumnHeading && index === 0; else bodyCell"
  [ngClass]="cellClasses"
  scope="row"
  (click)="row.children ? onToggleChildren(row) : null"
  (keyup.enter)="row.children ? onToggleChildren(row) : null"
  [tabIndex]="row.children ? 0 : -1"
>
  <ng-container *ngIf="false; else cellInner"></ng-container>
</th>

<ng-template #bodyCell>
  <td [ngClass]="cellClasses">
    <ng-container *ngIf="false; else cellInner"></ng-container>
  </td>
</ng-template>

<!-- Basic cell template -->
<ng-template #cellInner>
  <div class="cell-inner" [class]="{ center: isCellValueBoolean || column.align === 'center' }">
    <ng-container
      *ngIf="(!column.editable && !parent?.editable) || (column.editable && column.children && !column.childrenActive)"
    >
      <ng-container *ngIf="isCellValueBoolean">
        <ng-container *ngIf="cellValue === true">
          <app-icon
            [icon]="globalIcons.Check"
            [colour]="globalIconColours.CheckTeal"
            [size]="globalIconSizes.Medium"
          ></app-icon>
        </ng-container>
        <ng-container *ngIf="cellValue === false">
          <app-icon
            *ngIf="showFalseIcon"
            [icon]="globalIcons.X"
            [colour]="globalIconColours.Dark"
            [size]="globalIconSizes.Medium"
          ></app-icon>
          <div *ngIf="!showFalseIcon" class="sr-only">False</div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!isCellValueBoolean">
        <app-icon
          *ngIf="column.prefix === 'check' && cellValue > 0"
          [icon]="globalIcons.Check"
          [colour]="globalIconColours.CheckTeal"
          [size]="globalIconSizes.Medium"
          [margin]="{ right: 8 }"
        ></app-icon>
        {{ cellValue }}
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(column.editable && !column.children) || parent?.editable">
      <input
        appReadOnly
        class="hide-arrows"
        [attr.type]="inputType"
        [ignoreReadOnly]="ignoreReadOnly"
        [disabled]="disabled"
        [ngModel]="getCellValue()"
        (change)="setCellValue($event.target.value)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown.enter)="onEnter($event)"
        (keydown.esc)="$event.target.blur()"
        (paste)="onPaste($event)"
        [placeholder]="placeholder"
        step="any"
      />
    </ng-container>

    <button *ngIf="index === 0 && row.children?.length" aria-label="expand row" tabindex="-1">
      <app-icon [icon]="globalIcons.ChevronDown"></app-icon>
    </button>
  </div>
</ng-template>
